import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthMutation } from '@/api';
interface UsePostCustomPolicyFilterDataMutationParams {
  onSuccess?: () => void;
}
export const usePostCustomPolicyFilterDataMutation = params => {
  const $ = _c(10);
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthMutation["post:/wello/v2/auth/member-filter/fit"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== params || $[2] !== queryClient || $[3] !== toast) {
    t1 = () => {
      queryClient.invalidateQueries();
      toast({
        message: "\uC800\uC7A5\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      params?.onSuccess?.();
    };
    $[1] = params;
    $[2] = queryClient;
    $[3] = toast;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== toastError) {
    t2 = error => toastError({
      error
    });
    $[5] = toastError;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      ...t0,
      onSuccess: t1,
      onError: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useMutation(t3);
};